import {
    useState,
    forwardRef,
    useImperativeHandle,
} from 'react'

const NoticeStateOklahoma = forwardRef(({ data, company, refToPrint }, ref) => {

    const [requestReceiptCopy, setRequestReceiptCopy] = useState(data?.requestReceiptCopy ?? false)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                    requestReceiptCopy,
                },
            }
        },
    }))

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-2xl">
            <div ref={refToPrint} className="space-y-6 text-gray-900 text-base leading-relaxed w-full">
                <h2 className="text-2xl font-bold">
                    NOTICE REGARDING INVESTIGATIVE CONSUMER REPORTS PER OKLAHOMA LAW
                </h2>

                <p>
                    Pursuant to 24 Oklahoma Statutes § 148, {company?.name}, the "Company," will request or order a consumer report
                    from a third-party consumer reporting agency to be used in connection with your potential or continued employment.
                    These reports may contain information regarding your criminal history, social security verification, motor vehicle records,
                    verification of education or employment history, or other background checks. You have the right, upon request, to receive
                    a copy of any consumer report requested by the Company for this purpose. The scope of this disclosure is all-encompassing,
                    allowing the Company to obtain from any outside organization all manner of consumer reports throughout the course of
                    your employment to the extent permitted by law.
                </p>

                <div className="flex items-start space-x-2">
                    <input
                        type="checkbox"
                        checked={requestReceiptCopy}
                        onChange={(event) => setRequestReceiptCopy(!requestReceiptCopy)}
                        id="report-copy-request"
                        className="mt-1"
                        required
                    />
                    <label htmlFor="report-copy-request" className="text-gray-900">
                        Please check this box to receive from{" "}
                        <a
                            href="https://verifiedid.co"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            VerifiedID
                        </a>
                        ,{" "}
                        <a href="tel:+18887182597" className="text-blue-600 underline">
                            (888) 718-2597
                        </a>
                        , 11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA,{" "}
                        <a
                            href="https://verifiedid.co"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://verifiedid.co
                        </a>{" "}
                        a copy of any report furnished by VerifiedID to the Company pursuant to your authorization.
                    </label>
                </div>

            </div>

        </div>
    )

})

export default NoticeStateOklahoma
